import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable} from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorService } from 'src/app/error/err.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';
import { QueryEditorService } from 'src/app/language-service/query-editor.service';
import { LongPollingAPIManagement } from 'src/app/shared/stateapimanagement/longpolling-withstate';
import { LongPollingPromiseStatelessAPIManagement } from 'src/app/shared/stateapimanagement/promiselongpolling-withoutstate';
import { SharedService } from 'src/app/services/shared.service';
import { ToastService } from 'src/app/shared/custom-overlay/toast/toast.service';
import { API_STATEMANAGEMENT } from 'src/app/shared/stateapimanagement/api-statemanagement';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class LogSearchService  {

 

  landing = true;
  labelwidget: boolean = true;
  logSearchMetaData = this.sharedService.metaData.logsearch;
  commonData = this.sharedService.metaData.commonData;
  lables = this.logSearchMetaData.log_search_common.lables;
  searchDefault = this.logSearchMetaData.log_search_defaults.log_search_bar;
  multiSearchState_ = new BehaviorSubject(false);
  multiSearchState$ = this.multiSearchState_.asObservable();
  platformFields: any;
  allFieldsList: any = [];
  allFields: any;
  tableHeaders: any[] = [];
  hiddenFields;
  listTableHeaders = this.logSearchMetaData.log_search_result.right_panel.list_view.list_table_headers;
  savedAssets = this.logSearchMetaData.log_search_defaults.savedAssets;
  resultFilters = { "filters": [] };
  _queryType = new Subject;
  searchObj = {
    searchtokenisedcontext: [],
    errors: []
  };
  queryType$ = this._queryType.asObservable();
  searchContext = {};
  totEventsNum = 0;
  fetchedEvents: any = {};
  selectedHosts = [];
  availableTimerange = [];
  _resultRequest = new Subject();
  resultRequest$ = this._resultRequest.asObservable();
  componentdestroyed: Subject<number> = new Subject();
  analyticstimevalue = ""

  suggestion_selected_platform = this.sharedService.platformMap[this.sharedService.metaData.commonData.platformOptions.default]

  stateObject = {
    isLoaded: false,
    tabIndex: 0,
    itemPerPage: this.logSearchMetaData.log_search_defaults.pagination.itemPerPage,
    analyticsitemperpage: this.logSearchMetaData.log_search_defaults.pagination.itemPerPage,
    pageNumber: 1,
    totalPages: 1,
    analyticpage: 1,
    searchData: {
      impactedHosts: this.logSearchMetaData.log_search_defaults.savedAssets,
      selectedHostsLength: this.logSearchMetaData.log_search_defaults.savedAssets.uniqueHostsLength,
      timeRange: [],
      selectedAsset: this.searchDefault.asset.value,
      listOfHosts: {}
    }
  }
  oldTEN: number; // change by aju 12-09-2023 
  oldFTD: number; // change by aju 12-09-2023 
  oldTR: any; // change by aju 12-09-2023 
  requestTimeformat: string = "YYYY-MM-DD HH:mm:ss"

  historyindex: number = 0;
  finalpagereached: boolean = false;
  approximationSymbol = "approx. "
  customerChangeLogggedOff: Subject<boolean> = new Subject();
  searchSeggestionFilters: any = {
    "hosts": [],
    "platform": "",
    "time_range": {},
    "time_range_disp": "Last 7 Days",
    "selectedHost": []
  }
  // notepadCollection = JSON.parse(JSON.stringify(this.logSearchMetaData.log_search_defaults.search_notebook))
  notepadCollection=[]
  notepadCollectionTab=[]

  threatHunting=this.logSearchMetaData.log_search_defaults.search_notebook

  tabs=[]
  // notepadCollection=[
  //   {
  //     "id": 2,
  //     "text": "Item 3",
  //     "sqlquery": "action = \"deny\" | fetch service",
  //     "showResultSection": true,
  //     "platform": "",
  //     "selectedHosts": [
  //       "event",
  //       "traffic"
  //     ],
  //     "data": null,
  //     "filters": [],
  //     "timeRange": {
  //       "disp": "Last 7 Days",
  //       "value": [
  //         "-",
  //         "day",
  //         6,
  //         0
  //       ]
  //     },
  //     "limit": true,
  //     "searchRequest": {
  //       "platform": "firewall_fortigate",
  //       "time_range": [
  //         "2025-12-19 00:00:00",
  //         "2025-12-25 06:43:20"
  //       ],
  //       "tokens": {
  //         "SearchCommand": [
  //           {
  //             "cat": "field",
  //             "type": "text",
  //             "alias": "action",
  //             "image": "action"
  //           },
  //           {
  //             "cat": "operator",
  //             "type": "",
  //             "image": "=",
  //             "alias": "="
  //           },
  //           {
  //             "cat": "value",
  //             "type": "text",
  //             "image": "deny"
  //           }
  //         ],
  //         "FetchCommand": [
  //           {
  //             "cat": "field",
  //             "type": "text",
  //             "alias": "service",
  //             "image": "service"
  //           }
  //         ],
  //         "LimitCommand": [
  //           {
  //             "cat": "value",
  //             "type": "number",
  //             "image": "100",
  //             "alias": "100"
  //           }
  //         ]
  //       },
  //       "user_name": "Super@centiyent.com",
  //       "time": "2025-12-25 06:43:20",
  //       "hosts": [
  //         "event",
  //         "traffic"
  //       ],
  //       "page_no": 1,
  //       "items_per_page": 25,
  //       "filter_by": [],
  //       "field_name": [],
  //       "total_no_events": 0,
  //       "selected_time_range": [
  //         "2025-12-19 00:00:00",
  //         "2025-12-25 06:43:20"
  //       ],
  //       "fetched_trail_details": {},
  //       "direction": 0
  //     },
  //     "resultReceivedState": true,
  //     "editor": {},
  //     "impactedHosts": {
  //       "platform": "firewall_fortigate",
  //       "selectedTags": [],
  //       "excludedHosts": {},
  //       "selectedHosts": [
  //         "event",
  //         "traffic"
  //       ],
  //       "value": [
  //         {
  //           "disp": "Event",
  //           "tags": "Select all",
  //           "value": "event",
  //           "selected": false,
  //           "isSelected": true,
  //           "index": 0
  //         },
  //         {
  //           "disp": "Traffic",
  //           "tags": "Select all",
  //           "value": "traffic",
  //           "selected": false,
  //           "isSelected": true,
  //           "index": 1
  //         }
  //       ],
  //       "toggleControl": false,
  //       "uniqueHostsList": [
  //         "event",
  //         "traffic"
  //       ],
  //       "uniqueHostsLength": 2
  //     }
  //   },
  //   {
  //     "id": 1,
  //     "text": "Item 1",
  //     "sqlquery": "action = \"deny\" | fetch service,action,dstport",
  //     "showResultSection": true,
  //     "platform": "",
  //     "selectedHosts": [
  //       "event",
  //       "traffic"
  //     ],
  //     "data": null,
  //     "filters": [],
  //     "timeRange": {
  //       "disp": "Last 7 Days",
  //       "value": [
  //         "-",
  //         "day",
  //         6,
  //         0
  //       ]
  //     },
  //     "limit": true,
  //     "searchRequest": {
  //       "platform": "firewall_fortigate",
  //       "time_range": [
  //         "2025-12-19 00:00:00",
  //         "2025-12-25 06:41:11"
  //       ],
  //       "tokens": {
  //         "SearchCommand": [
  //           {
  //             "cat": "field",
  //             "type": "text",
  //             "alias": "action",
  //             "image": "action"
  //           },
  //           {
  //             "cat": "operator",
  //             "type": "",
  //             "image": "=",
  //             "alias": "="
  //           },
  //           {
  //             "cat": "value",
  //             "type": "text",
  //             "image": "deny"
  //           }
  //         ],
  //         "FetchCommand": [
  //           {
  //             "cat": "field",
  //             "type": "text",
  //             "alias": "service",
  //             "image": "service"
  //           },
  //           {
  //             "cat": "field",
  //             "type": "text",
  //             "alias": "action",
  //             "image": "action"
  //           },
  //           {
  //             "cat": "field",
  //             "type": "number",
  //             "alias": "dstport",
  //             "image": "dstport"
  //           }
  //         ],
  //         "LimitCommand": [
  //           {
  //             "cat": "value",
  //             "type": "number",
  //             "image": "100",
  //             "alias": "100"
  //           }
  //         ]
  //       },
  //       "user_name": "Super@centiyent.com",
  //       "time": "2025-12-25 06:41:11",
  //       "hosts": [
  //         "event",
  //         "traffic"
  //       ],
  //       "page_no": 1,
  //       "items_per_page": 25,
  //       "filter_by": [],
  //       "field_name": [],
  //       "total_no_events": 0,
  //       "selected_time_range": [
  //         "2025-12-19 00:00:00",
  //         "2025-12-25 06:41:11"
  //       ],
  //       "fetched_trail_details": {},
  //       "direction": 0
  //     },
  //     "resultReceivedState": true,
  //     "editor": {},
  //     "impactedHosts": {
  //       "platform": "firewall_fortigate",
  //       "selectedTags": [],
  //       "excludedHosts": {},
  //       "selectedHosts": [
  //         "event",
  //         "traffic"
  //       ],
  //       "value": [
  //         {
  //           "disp": "Event",
  //           "tags": "Select all",
  //           "value": "event",
  //           "selected": false,
  //           "isSelected": true,
  //           "index": 0
  //         },
  //         {
  //           "disp": "Traffic",
  //           "tags": "Select all",
  //           "value": "traffic",
  //           "selected": false,
  //           "isSelected": true,
  //           "index": 1
  //         }
  //       ],
  //       "toggleControl": false,
  //       "uniqueHostsList": [
  //         "event",
  //         "traffic"
  //       ],
  //       "uniqueHostsLength": 2
  //     }
  //   }
  // ]

  // notepadCollection=[
  //   {
  //     "id": 1,
  //     "text": "Item 1",
  //     "sqlquery": "action = \"deny\" | fetch service,action,dstport",
  //     "showResultSection": false,
  //     "platform": "",
  //     "selectedHosts": [
  //       "event",
  //       "traffic"
  //     ],
  //     "data": null,
  //     "filters": [],
  //     "timeRange": {
  //       "disp": "Last 7 Days",
  //       "value": [
  //         "-",
  //         "day",
  //         6,
  //         0
  //       ]
  //     },
  //     "limit": true,
  //     "searchRequest": {},
  //     "resultReceivedState": false,
  //     "editor": {},
  //     "impactedHosts": {
  //       "platform": "firewall_fortigate",
  //       "selectedTags": [],
  //       "excludedHosts": {},
  //       "selectedHosts": [
  //         "event",
  //         "traffic"
  //       ],
  //       "value": [
  //         {
  //           "disp": "Event",
  //           "tags": "Select all",
  //           "value": "event",
  //           "selected": false,
  //           "isSelected": true,
  //           "index": 0
  //         },
  //         {
  //           "disp": "Traffic",
  //           "tags": "Select all",
  //           "value": "traffic",
  //           "selected": false,
  //           "isSelected": true,
  //           "index": 1
  //         }
  //       ],
  //       "toggleControl": false,
  //       "uniqueHostsList": [
  //         "event",
  //         "traffic"
  //       ],
  //       "uniqueHostsLength": 2
  //     }
  //   }
  // ]

  resetSerarchSuggestionFilters() {
    this.searchSeggestionFilters = {
      "hosts": [],
      "platform": "",
      "time_range": {},
      "time_range_disp": "Last 7 Days",
      "selectedHost": []
    }
  }
  // relative_times=[{
  //   "disp": "Last 24 Hours",
  //   "value": [
  //     "-",
  //     "hour",
  //     24,
  //     0
  //   ]
  // },{
  //   "disp": "Last 7 Days",
  //   "value": [
  //     "-",
  //     "day",
  //     6,
  //     0
  //   ]
  // },
  // {
  //   "disp": "Last 10 Days",
  //   "value": [
  //     "-",
  //     "day",
  //     9,
  //     0
  //   ]

  // },
  // {
  //   "disp": "Last 30 Days",
  //   "value": [
  //     "-",
  //     "day",
  //     29,
  //     0
  //   ]

  // }
  // ]

  addTab(){
    this.tabs.push("new Tab")
}
removeTab(){
  this.tabs.pop()
}
  relative_times = this.sharedService.metaData.logsearch.common_top_bar.search_bar.time_panel.relative_time_options
  initiateState() {
    if (!this.stateObject.isLoaded) {
      this.logSearchMetaData.log_search_defaults.savedAssets.platform = this.sharedService.metaData.commonData.platformOptions.default
      this.logSearchMetaData.log_search_defaults.savedAssets.selectedHosts = this.sharedService.hostlist
      this.logSearchMetaData.log_search_defaults.savedAssets.uniqueHostsList = this.sharedService.hostlist
      this.logSearchMetaData.log_search_defaults.savedAssets.uniqueHostsLength = this.sharedService.hostlist.length
      this.fetchedEvents = {};
      this.totEventsNum = 0;
      this.searchDefault = JSON.parse(JSON.stringify(this.logSearchMetaData.log_search_defaults.log_search_bar));
      this.stateObject.searchData.impactedHosts = this.logSearchMetaData.log_search_defaults.savedAssets;
      this.stateObject.searchData.timeRange = this.searchDefault.timeRange;
      this.stateObject.searchData.selectedHostsLength = this.logSearchMetaData.log_search_defaults.savedAssets.uniqueHostsLength;
      this.stateObject.itemPerPage = this.logSearchMetaData.log_search_defaults.pagination.itemPerPage;
      this.stateObject.pageNumber = 1;
      this.stateObject.totalPages = 1;
      this.processPlatformFields(JSON.parse(JSON.stringify(this.sharedService.commonPlatformFields)));
      this.updatehistory(this.getusernameobj());
      this.updatefav(this.getusernameobj());
      // this.updatesavedsearch(this.getusernameobj());
    }
  }

  updatehistory(reqobj: any) {
    this.getHistory(reqobj).subscribe(history => {
      this.historylist = [...history.history_table_rows];
      if (this.historylist.length) {
        this.historyindex = 0;
      } else {
        this.historyindex = 3;
      }
    })
  }

  public _history = new Subject<any | null>();
  public $history = this._history.asObservable();

  historyList={}

  async getHistoryList(){
    // console.log("Instance 2")
    
    await this.getHistory(this.getusernameobj().userName).pipe(takeUntil(this.componentdestroyed),distinctUntilChanged()).subscribe(data=>{
      // console.log("Instance 3")
        this.historyList=data.history_table_rows
        // console.log(this.historylist)
        this._history.next(this.historyList)
    })
    
  }

  updatefav(reqobj: any) {
    this.getFavorites(reqobj).subscribe(favourites_table_rows => {
      this.favoriteslist = [...favourites_table_rows.favourites_table_rows]
    })
  }

  updatesavedsearch(reqobj: any) {
    this.getSavedSearch(reqobj).subscribe(savedSearch => {
      this.savedSearchlist = [...savedSearch.savedsearch_table_rows];
    })
  }

  checklogged() {
    return this.sharedService.$userLogged.getValue();
  }

  resetStateObj() {
    this.stateObject.isLoaded = false;
    this.initiateState();
  }

  selHost: boolean = false;

  processPlatformFields(platformFields: any[]) {
    const newplatformlist = [];
    for (let i = 0; i < platformFields.length; i++) {
      if (platformFields[i].is_view) {
        newplatformlist.push(platformFields[i]);
      }
    }
    this.platformFields = newplatformlist;
    this.allFieldsList = platformFields;
  }
  // Need to remove as per shared service

  headers = new HttpHeaders({ 'content-type': 'application/json', 'charset': 'utf-8' });
  url = {
    "HG": environment.apiUrl + "/logsearch/history/get",
    "HP": environment.apiUrl + "/logsearch/history/post",
    "SSG": environment.apiUrl + "/logsearch/savedSearch/get",
    "SSP": environment.apiUrl + "/logsearch/savedSearch/post",
    "FG": environment.apiUrl + "/logsearch/favourite/get",
    "FP": environment.apiUrl + "/logsearch/favourites/post",
    "FVG": environment.apiUrl + "/logsearch/platform/fieldValues/get",
    "PFG": environment.apiUrl + "/logsearch/platform/fields/get",
    "FSG": environment.apiUrl + "/logsearch/fieldStat/get",
    "PHG": environment.apiUrl + "/logsearch/hosts/get",
    "SRG": environment.apiUrl + "/logsearch/searchResult/get",
    "RAG": environment.apiUrl + "/logsearch/analytics/get",
    "HMG": environment.apiUrl + "/logsearch/heatmap/get",
    "UG": environment.apiUrl + "/settings/role/userList/get",
    "URP": environment.apiUrl + "/logsearch/user/recentSession/post",
    "URG": environment.apiUrl + "/logsearch/user/recentSession/get",
    "THS": environment.apiUrl + "/logsearch/threat_hunt/save/post",
    "THU": environment.apiUrl + "/logsearch/threat_hunt/update/post",
    "THL": environment.apiUrl + "/logsearch/threat_hunt/list/get",
    
  }

  savedSearch$ = this.getSavedSearch(this.getusernameobj());

  historylist = [];
  //historyspinner:boolean = false;
  favoriteslist = [];
  //favoritesspinner:boolean = false;
  savedSearchlist = [];

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private errorservice: ErrorService,
    private timeZoneService: TimeZoneService,
    private queryeditorService: QueryEditorService,
    private toastService: ToastService

  ) {
    this.sharedService.$userLoggedoff.pipe().subscribe((loggedoff) => {
      this.customerChangeLogggedOff.next(loggedoff);
    })
    this.sharedService.customerChanged_.subscribe(() => {
      this.resetLogsearch()
      this.customerChangeLogggedOff.next(true);
    })

    this.sharedService.userLoggedoff_.subscribe((val: boolean) => {
      this.resetLogsearch()
    })
  }

  

  resetLogsearch() {
    this.resetStateObj();
    this.resultFilters.filters.length = 0;
    this.landing = true;
    this.labelwidget = false;
    this.queryeditorService.editorValue = "";
    this.selHost = false;
    this.stateObject.analyticpage = 1;
    this.stateObject.analyticsitemperpage = this.logSearchMetaData.log_search_defaults.pagination.itemPerPage;
    this.analyticstimevalue = "";
    this.resetSerarchSuggestionFilters();
    // this.notepadCollection = JSON.parse(JSON.stringify(this.logSearchMetaData.log_search_defaults.search_notebook))
  }
  prepareTextCdnStr(txtObj) {
    let strcombo = []
    txtObj.forEach(element => {
      if (element.operator != "=") {
        let searchStr = ""
        searchStr = searchStr + element.field + " " + element.operator + " [\""
        searchStr = searchStr + element.value.join("\",\"")
        searchStr = searchStr + "\"]"
        strcombo.push(searchStr)
      }
      else {
        let searchStr = ""
        searchStr = searchStr + element.field + " " + element.operator + " \"" + element.value.join("\",\"") + "\""
        strcombo.push(searchStr)
      }
    });
    return strcombo.join(" AND ")
  }
  prepareTextCdn(txtObj) {
    let strcombo = []
    txtObj.forEach(element => {
      if (element.operator != "=") {
        let searchStr = ""
        searchStr = searchStr + " [\""
        searchStr = searchStr + element.value.join("\",\"")
        searchStr = searchStr + "\"]"
        strcombo.push({ "image": element.field, "cat": 'field' })
        strcombo.push({ "image": element.operator, "cat": 'operator' })
        strcombo.push({ "image": searchStr, "cat": 'operator' })
        strcombo.push({ "image": "AND", "cat": 'termoperator' })
      }
      else {
        let searchStr = ""
        searchStr = searchStr + element.field + " " + element.operator + " \"" + element.value.join("\",\"") + "\""
        strcombo.push({ "image": element.field, "cat": 'field' })
        strcombo.push({ "image": element.operator, "cat": 'operator' })
        strcombo.push({ "image": searchStr, "cat": 'operator' })
        strcombo.push({ "image": "AND", "cat": 'termoperator' })
      }
    });
    return strcombo
  }
  getusername() {
    return this.sharedService.userName
  }

  getusernameobj() {
    return { "userName": this.sharedService.userName, "asset": this.stateObject.searchData.impactedHosts.platform };
  }

  getResultFilters() {
    return this.resultFilters;
  }

  postThreatHuntingSave(request){
    return this.http.post<any>(this.url.THS, request, { headers: this.headers });
  }

  postThreatHuntingUpdate(request){
    return this.http.post<any>(this.url.THU, request, { headers: this.headers });
  }

  getThreatHuntingList(request){
    return this.http.post<any>(this.url.THL, request, { headers: this.headers });
  }

  getHistory(request) {
    return this.http.post<any>(this.url.HG, JSON.stringify({"userName":request}), { headers: this.headers });
  }

  getRecentSession(request){
    return this.http.post<any>(this.url.URG, request, { headers: this.headers });
  }

  postRecentSession(request){
    return this.http.post<any>(this.url.URP, request, { headers: this.headers });
  }

  getFavorites(request) {
    return this.http.post<any>(this.url.FG, {"userName":request}, { headers: this.headers });
  }

  getSavedSearch(request) {
    return this.http.post<any>(this.url.SSG, request, { headers: this.headers });
  }

  getHosts(request) {
    return this.http.post<any>(this.url.PHG, JSON.stringify(request), { headers: this.headers });
  }

  postHistory(history) {
    return this.http.post<any>(this.url.HP, JSON.stringify(history), { headers: this.headers })
  }

  putFavorite(favourite) {
    return this.http.post<any>(this.url.FP, JSON.stringify(favourite), { headers: this.headers })
  }

  postSaveSearch(search) {
    return this.http.post<any>(this.url.SSP, JSON.stringify(search), { headers: this.headers })
  }

  checkIfThreatHuntnameExists(rulename: string) {
    return this.http.post(environment.apiUrl + '/logsearch/threat_hunt/name/check', this.toStringify({ threatHuntName: rulename }), { headers: this.headers })
  }

  checkIfSaveResultnameExists(rulename: string,threatHuntName,user_id) {
    return this.http.post(environment.apiUrl + '/logsearch/saveSearchResult/name/check', this.toStringify({ searchResultName:rulename,threatHuntName: threatHuntName ? threatHuntName : 'general' ,user_id:user_id}), { headers: this.headers })
  }


  getPartitionsList(request: any) {
    return this.http.post<any>(environment.apiUrl + "/assets/partitions/get", request, { headers: this.headers });
  }

  deleteThreatHunt(request:any){
    return this.http.post<any>(environment.apiUrl + "/logsearch/threat_hunt/list/delete", request, { headers: this.headers });
  }

toStringify(postData: any) {
  return JSON.stringify(postData)
}

postSearchresultNew = (() => {
  return new LongPollingAPIManagement(
    this.saveSearchResult,
    this.http,
    this.componentdestroyed.asObservable(),
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    '/logsearch/saveSearchResult/post',
    'Logsearch',
    this.toastService
  )
})

provideStats = new API_STATEMANAGEMENT(
  this.providestats, 
  this.http, 
  this.componentdestroyed.asObservable(), 
  this.customerChangeLogggedOff.asObservable()
)
providestats(request: any) {
  return this.http.post(environment.apiUrl + '/logsearch/stats/get', request, { headers: this.headers })
}



  getSearchresult = (() => {
    return new LongPollingAPIManagement(
      this.getSearchResult,
      this.http,
      this.componentdestroyed.asObservable(),
      this.customerChangeLogggedOff.asObservable(),
      this.errorservice,
      '/logsearch/searchResult/get',
      'Logsearch',
      this.toastService
    )
  })




  getSearchresultNew = (() => {
    return new LongPollingAPIManagement(
      this.getSearchResultNew,
      this.http,
      this.componentdestroyed.asObservable(),
      this.customerChangeLogggedOff.asObservable(),
      this.errorservice,
      '/logsearch/searchResultNew/get',
      'Logsearch',
      this.toastService
    )
  })


  searchapi = this.getSearchresult()
  getSearchResult(request: any) {
    return this.http.post<any>(environment.apiUrl + "/logsearch/searchResult/get", request, { headers: this.headers })
  }

  getSearchResultNew(request: any) {

    return this.http.post<any>(environment.apiUrl + "/logsearch/searchResultNew/get", request, { headers: this.headers })
  }


 saveSearchResult(request) {
  return this.http.post<any>(environment.apiUrl + '/logsearch/saveSearchResult/post', request, { headers: this.headers })
}

  getUsers() {
    return this.http.post<any>(this.url.UG, {}, { headers: this.headers });
  }
  getFieldstat = (() => {
    return new LongPollingPromiseStatelessAPIManagement(
      this.getFieldStat,
      this.http,
      this.customerChangeLogggedOff.asObservable(),
      this.errorservice,
      this.toastService,
      '/logsearch/fieldStat/get',
      'Logsearch'
    )
  })
  fieldstatapi = this.getFieldstat()
  getFieldStat(request: any) {
    return this.http.post<any>(environment.apiUrl + "/logsearch/fieldStat/get", request, { headers: this.headers });
  }
  getanalytics = (() => {
    return new LongPollingAPIManagement(
      this.getAnalytics,
      this.http,
      this.componentdestroyed.asObservable(),
      this.customerChangeLogggedOff.asObservable(),
      this.errorservice,
      '/logsearch/analytics/get',
      'Logsearch',
      this.toastService
    )
  })
  analyticsapi = this.getanalytics()
  getAnalytics(request: any) {
    return this.http.post<any>(environment.apiUrl + "/logsearch/analytics/get", request, { headers: this.headers })
  }
  getheatmap = (() => {
    return new LongPollingAPIManagement(
      this.getHeatmap,
      this.http,
      this.componentdestroyed.asObservable(),
      this.customerChangeLogggedOff.asObservable(),
      this.errorservice,
      'logsearch/heatmap/get',
      'Logsearch',
      this.toastService
    )
  })
  heatmapapi = this.getheatmap()
  getHeatmap(request) {
    return this.http.post<any>(environment.apiUrl + "/logsearch/heatmap/get", request, { headers: this.headers })
  }

  getCommonPlatformFields(platform: any) {
    return this.http.post(environment.apiUrl + '/common/platformFields/get', JSON.stringify(platform), { headers: this.headers })
  }


  timeRangeCalc(input) {
    let userCurrentTime = this.timeZoneService.getcurrentuserTime()

    if (input[0] == '-' && input[1] == 'minute') {
      return [userCurrentTime.clone().subtract(input[2], 'minute').format(this.requestTimeformat), userCurrentTime.format(this.requestTimeformat)];
    }
    else if (input[0] == '-' && input[1] == 'hour') {
      return [userCurrentTime.clone().subtract(input[2], 'hour').format(this.requestTimeformat), userCurrentTime.format(this.requestTimeformat)];
    }
    else if (input[0] == '-' && input[1] == 'day') {
      return [userCurrentTime.clone().subtract(input[2], 'days').startOf('D').format(this.requestTimeformat), userCurrentTime.format(this.requestTimeformat)];
    }
    else if (input[0] == '*' && input[1] == 'day') {
      const newDate = userCurrentTime.clone().subtract(input[2], 'days');
      if (input[2] == 0) {
        return [newDate.clone().startOf('D').format(this.requestTimeformat), userCurrentTime.format(this.requestTimeformat)];
      } else {
        return [newDate.clone().startOf('D').format(this.requestTimeformat), newDate.clone().endOf('D').format(this.requestTimeformat)];
      }
    }
    else if (input[0] == '-' && input[1] == 'week') {
      const previousWeeks = userCurrentTime.clone().subtract(input[2], 'weeks');
      const lastsWeek = userCurrentTime.clone().subtract(1, 'weeks');

      return [previousWeeks.startOf('week').format(this.requestTimeformat), lastsWeek.endOf('week').format(this.requestTimeformat)];
    }
    else if (input[0] == '-' && input[1] == 'month') {
      const previouMonths = userCurrentTime.clone().subtract(input[2], 'months');
      const endOfLastMonth = userCurrentTime.clone().subtract(1, 'months');
      return [previouMonths.startOf('month').format(this.requestTimeformat), endOfLastMonth.endOf('month').format(this.requestTimeformat)];
    }
    else if (input[0] == '-' && input[1] == 'year') {
      return [userCurrentTime.clone().subtract(input[2], 'year').format(this.requestTimeformat), userCurrentTime.format(this.requestTimeformat)];
    }
    else return [input[0], input[1]]
  }

  //to structure the filters like Event Id = '1234'
  structureFilters_new(filters: any) {
    const filterarr = [];
    for (let i = 0; i < filters.length; i++) {
      filterarr.push(
        {
          image: "AND",
          cat: 'termoperator'
        },
        {
          image: filters[i].key,
          cat: 'field'
        },
        {
          image: filters[i].operator,
          cat: 'operator'
        },
        {
          image: filters[i].value,
          cat: 'value'
        }
      )
    }
    return filterarr
  }

  structureFilters(filters: any) {
//console.log("filters", filters)
    let keys = {}
    filters.forEach(element => {
      if (keys[element.field]) {
        keys[element.field].push(element)
      } else {
        keys[element.field] = [element]
      }
    });
    let condition = []
    for (let key in keys) {
      condition.push({
        "cat": "termoperator",
        "type": "",
        "image": "AND"
      })
      condition.push({
        "cat": keys[key][0]["is_platformField"] ? "field" : "tablecolumn",
        "type": keys[key][0]["type"],
        "alias": key,
        "image": key
      })
      condition.push({
        "cat": "operator",
        "type": "",
        "image": "IN"
      })
      let valuearr = {
        "cat": "value",
        "type": keys[key][0]["type"],
        "image": []
      }
      keys[key].forEach((element) => {
        valuearr.image.push(element.value)
      })

      condition.push(valuearr)
    }
    return condition
  }

  historytopost = {
    pending: false,
    reqobj: null
  }
  calcTimeRange(value) {
    const usertimerange = this.timeRangeCalc(value);
    // console.log({usertimerange})
    const min_time_of_data = this.sharedService.timeRange['event_time_range'][0]
    let req_stime = this.timeZoneService.toUtcTimeZonefromUser(usertimerange[0]).unix()
    let req_endtime = this.timeZoneService.toUtcTimeZonefromUser(usertimerange[1]).unix()

    if (req_stime < min_time_of_data && req_endtime > min_time_of_data) {
      return [this.timeZoneService.toUtcTimeZonefromUser(min_time_of_data).format('YYYY-MM-DD HH:mm:ss'), this.timeZoneService.toUtcTimeZonefromUser(usertimerange[1]).format('YYYY-MM-DD HH:mm:ss')]
    }
    else {
      return [this.timeZoneService.toUtcTimeZonefromUser(usertimerange[0]).format('YYYY-MM-DD HH:mm:ss'), this.timeZoneService.toUtcTimeZonefromUser(usertimerange[1]).format('YYYY-MM-DD HH:mm:ss')];
    }
  }
}
